import React from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import { Resizable } from 're-resizable';
// ⚠️ must needed !
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/javascript-lint';
import 'codemirror/addon/lint/lint.css';
import './pureEditor.scss';

const PureEditor = ({ value, options, onChange, resizable = false }) => {
  return resizable ? (
    <Resizable
      defaultSize={{
        height: 300,
      }}
      minHeight={300}
      minWidth={'50vw'}
    >
      <div className="resizable-editor-wrapper">
        <CodeMirror value={value} options={options} onBeforeChange={onChange} />
        <span className="cke_bottom bottom">
          <span className="cke_resizer">◢</span>
        </span>
      </div>
    </Resizable>
  ) : (
    <CodeMirror value={value} options={options} onBeforeChange={onChange} />
  );
};

export default PureEditor;
